import { deleteRequestWrapper } from "../../utilities";

export type deleteVersionResponse = { success: boolean };

export function deleteVersion(
  id: string,
  authId: string
): Promise<deleteVersionResponse> {
  return deleteRequestWrapper<never, deleteVersionResponse>({
    url: `${ENV_SETTINGS.API_URL}/versions/${id}`,
    idToken: authId,
  });
}
